export const timeAttendanceKeys = {
  all: ['timeAttendance'] as const,
  currentEntry: (profileId: string) => [...timeAttendanceKeys.all, 'currentEntry', profileId] as const,
  entries: (profileId: string) => [...timeAttendanceKeys.all, 'entries', profileId] as const,
};
